<template>
    <div class="step-layout seven">
        <!-- ---------------------------- Step Intro Section ---------------------------- -->
        <section class="step-layout-left bg-7">
            <div class="step-layout-container">
                <div class="progressbar">
                    <ul>
                        <li class="completed">Your city {{ selectedCity }}</li>
                        <li class="completed">Contact Details</li>
                        <li class="completed">Home Type</li>
                        <li class="completed">Other Details</li>
                        <li class="active">Home Details</li>
                    </ul>
                </div>
                <h2
                    class="text-white intro-title d-none d-sm-block"
                    data-aos="fade-up"
                    data-aos-duration="1300"
                >
                    These questions help us reach<br />
                    out to explain all your selling<br />
                    options better!
                </h2>
                <h2
                    class="text-white intro-title d-block d-sm-none text-center"
                    data-aos="zoom-in"
                    data-aos-duration="1300"
                >
                    These questions help us reach out to explain all your
                    selling options better!
                </h2>
                <!-- Back Button -->
                <div
                    class="text-center text-sm-left"
                    data-aos="fade-up"
                    data-aos-duration="1600"
                >
                    <a
                        href="javascript:void(0)"
                        v-on:click="goBack()"
                        class="btn btn-primary"
                    >
                        <i class="fa-solid fa-circle-arrow-left mr-2"></i>BACK
                    </a>
                </div>
            </div>
        </section>
        <!-- -------------------------- Step Form Section -------------------------- -->
        <section class="step-layout-right">
            <div
                class="step-layout-container pb-2"
                data-aos="fade-left"
                data-aos-duration="1500"
            >
                <h2 class="text-primary title">
                    Help us contact you with the perfect offer!
                </h2>
                <form
                    class="text-center home-details-form"
                    action="#"
                    @submit.prevent="submitForm"
                >
                    <!-- Bedrooms Select -->
                    <div
                        class="form-group grid-select"
                        :class="showError && !bedrooms ? 'border-danger' : ''"
                    >
                        <select
                            class="form-control selectpicker"
                            v-model="bedrooms"
                        >
                            <option value="" :disabled="true">
                                Bedrooms (Above ground)
                            </option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6+">6+</option>
                        </select>
                        <small
                            v-if="showError && !bedrooms"
                            class="text-danger d-block text-left mt-3"
                        >
                            <b>* Bedrooms are mandatory</b>
                        </small>
                    </div>
                    <!-- Bathrooms Select -->
                    <div
                        class="form-group grid-select"
                        :class="showError && !bathrooms ? 'border-danger' : ''"
                    >
                        <select
                            class="form-control selectpicker"
                            v-model="bathrooms"
                        >
                            <option value="" :disabled="true">Bathrooms</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6+">6+</option>
                        </select>
                        <small
                            v-if="showError && !bathrooms"
                            class="text-danger d-block text-left mt-3"
                        >
                            <b>* Bathrooms are mandatory</b>
                        </small>
                    </div>

                    <!-- Square footage (Above ground) -->
                    <div class="form-group list-select">
                        <select
                            class="form-control selectpicker"
                            v-model="square_foot"
                        >
                            <option value="" :disabled="true">
                                Square footage (Above ground)
                            </option>
                            <option value="500-1000">500-1000</option>
                            <option value="1000-2000">1000-2000</option>
                            <option value="2000-3000">2000-3000</option>
                            <option value="3000-4000">3000-4000</option>
                            <option value="4000+">4000+</option>
                        </select>
                    </div>
                    <!-- Style of home -->
                    <div class="form-group list-select">
                        <select
                            class="form-control selectpicker"
                            v-model="home_style"
                        >
                            <option value="" :disabled="true">
                                Style of home
                            </option>
                            <option value="2-story">2 Story</option>
                            <option value="3-story">3 Story</option>
                            <option value="Bungalow">Bungalow</option>
                            <option value="Back split">Back split</option>
                            <option value="Side split">Side split</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>
                    <!-- Garage spaces -->
                    <div
                        class="form-group grid-select"
                        :class="showError && !garage ? 'border-danger' : ''"
                    >
                        <select
                            class="form-control selectpicker"
                            v-model="garage"
                        >
                            <option value="" :disabled="true">
                                Garage spaces
                            </option>
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3+">3+</option>
                            <!-- <option value="4+">4+</option> -->
                        </select>
                        <small
                            v-if="showError && !garage"
                            class="text-danger d-block text-left mt-3"
                        >
                            <b>* Garage spaces are mandatory</b>
                        </small>
                    </div>

                    <!-- Any details -->
                    <div class="form-group form-group-lg">
                        <textarea
                            class="form-control"
                            rows="3"
                            v-model="comment"
                            placeholder="Any details that you want to add"
                        ></textarea>
                    </div>
                    <!-- Submit Button -->
                    <div class="text-left text-lg-right submit-btn-wrapper">
                        <button
                            type="submit"
                            class="btn btn-primary btn-lg submit-btn"
                            @submit.prevent="submitForm()"
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "PropertyValuationStepSeven",
    data() {
        return {
            valuationStep: 7,
            selectedCity: "Toronto",
            selectedAddress: "",
            name: "",
            email: "",
            phone: "",
            propertyType: "Detached",
            basePresent: "Yes",
            bedrooms: "",
            bathrooms: "",
            square_foot: "",
            home_style: "",
            garage: "",
            comment: "",
            utm_source: "RedBuyers",
            utm_medium: "redbuyers.com",
            utm_campaign: "IN_HOUSE",
            utm_id: "REDBUYERS",
            utm_content: "Seventh Step",
            buttonClicked: false,
            valuation_property_unit: "",
            valuation_property_finshed_basement_type: "",
        };
    },
    computed: {
        formInvalid() {
            if (this.bedrooms && this.bathrooms && this.garage) {
                return false;
            } else {
                return true;
            }
        },
        showError() {
            if (this.formInvalid && this.buttonClicked) {
                return true;
            } else {
                return false;
            }
        },
    },
    watch: {
        bedrooms(value) {
            if (value) {
                sessionStorage.setItem("valuation_bed", value);
            }
        },
        bathrooms(value) {
            if (value) {
                sessionStorage.setItem("valuation_bath", value);
            }
        },
        square_foot(value) {
            if (value) {
                sessionStorage.setItem("valuation_square_foot", value);
            }
        },
        home_style(value) {
            if (value) {
                sessionStorage.setItem("valuation_home_style", value);
            }
        },
        garage(value) {
            if (value) {
                sessionStorage.setItem("valuation_garage", value);
            }
        },
        comment(value) {
            if (value) {
                sessionStorage.setItem("valuation_comment", value);
            }
        },
    },
    mounted() {
        if (sessionStorage.getItem("valuation_city")) {
            this.selectedCity = sessionStorage.getItem("valuation_city");
        }
        if (sessionStorage.getItem("valuation_address")) {
            this.selectedAddress = sessionStorage.getItem("valuation_address");
        }
        //step-1 data
        if (sessionStorage.getItem("valuation_name")) {
            this.name = sessionStorage.getItem("valuation_name");
        }
        if (sessionStorage.getItem("valuation_email")) {
            this.email = sessionStorage.getItem("valuation_email");
        }
        if (sessionStorage.getItem("valuation_phone")) {
            this.phone = sessionStorage.getItem("valuation_phone");
        }
        //step-2 data
        if (sessionStorage.getItem("valuation_property_type")) {
            this.propertyType = sessionStorage.getItem("valuation_property_type");
        }
        if (sessionStorage.getItem("valuation_property_unit")) {
            this.valuation_property_unit = sessionStorage.getItem("valuation_property_unit");
        }
        //step-4 data
        if (sessionStorage.getItem("valuation_basement_present")) {
            this.basePresent = sessionStorage.getItem("valuation_basement_present");
        }
        if (sessionStorage.getItem("valuation_property_finshed_basement_type")) {
            this.valuation_property_finshed_basement_type = sessionStorage.getItem("valuation_property_finshed_basement_type");
        }
        //step-7 data
        if (sessionStorage.getItem("valuation_bed")) {
            this.bedrooms = sessionStorage.getItem("valuation_bed");
        }
        if (sessionStorage.getItem("valuation_bath")) {
            this.bathrooms = sessionStorage.getItem("valuation_bath");
        }
        if (sessionStorage.getItem("valuation_square_foot")) {
            this.square_foot = sessionStorage.getItem("valuation_square_foot");
        }
        if (sessionStorage.getItem("valuation_home_style")) {
            this.home_style = sessionStorage.getItem("valuation_home_style");
        }
        if (sessionStorage.getItem("valuation_garage")) {
            this.garage = sessionStorage.getItem("valuation_garage");
        }
        if (sessionStorage.getItem("valuation_comment")) {
            this.comment = sessionStorage.getItem("valuation_comment");
        }
        //other
        if (sessionStorage.getItem("valuation_utm_source")) {
            this.utm_source = sessionStorage.getItem("valuation_utm_source");
        }
        if (sessionStorage.getItem("valuation_utm_medium")) {
            this.utm_medium = sessionStorage.getItem("valuation_utm_medium");
        }
        if (sessionStorage.getItem("valuation_utm_campaign")) {
            this.utm_campaign = sessionStorage.getItem("valuation_utm_campaign");
        }
        if (sessionStorage.getItem("valuation_utm_id")) {
            this.utm_id = sessionStorage.getItem("valuation_utm_id");
        }
        if (sessionStorage.getItem("valuation_utm_content")) {
            this.utm_content = sessionStorage.getItem("valuation_utm_content");
        }
        if (sessionStorage.getItem("valuation_data")) {
            sessionStorage.removeItem("valuation_data");
        }
    },
    methods: {
        submitForm() {
            this.buttonClicked = true;
            if (!this.formInvalid) {
                const formData = new FormData();

                formData.append("utm_id", this.utm_id);
                formData.append("utm_source", this.utm_source);
                formData.append("utm_medium", this.utm_medium);
                formData.append("utm_campaign", this.utm_campaign);
                formData.append("utm_content", this.utm_content);

                formData.append("address", this.selectedAddress);
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("phone", this.phone);

                formData.append("type", this.propertyType);
                formData.append("valuation_property_unit",this.valuation_property_unit);
                
                formData.append("basement", this.basePresent);
                formData.append("valuation_property_finshed_basement_type",this.valuation_property_finshed_basement_type);

                formData.append("bedrooms", this.bedrooms);
                formData.append("bathrooms", this.bathrooms);
                formData.append("square_foot", this.square_foot);
                formData.append("home_style", this.home_style);
                formData.append("garage", this.garage);
                formData.append("comment",this.utm_content + " | " + this.comment);

                axios
                    .post("/direct-leads/submit-leads", formData)
                    .then((response) => {
                        console.log(response.data);
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally((result) => {
                        sessionStorage.removeItem("valuation_data");
                        window.location.href =
                            "/properties/valuation/submit/data/step-9";
                    });
            }
        },
        goBack() {
            window.location.href = "/properties/valuation/submit/data/step-4";
        },
    },
};
</script>

<style>
.border-danger
    > .dropdown.bootstrap-select.form-control.bs3
    .btn.dropdown-toggle.btn-default.bs-placeholder {
    border: 1px solid #dc3545 !important;
}
</style>
